/**
 * Chat Image Actions - Download + Save to Gallery buttons per image
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Download, ImagePlus, Check } from 'lucide-react';
import { Button } from '@/components/v2/ui';
import { useSaveToGallery } from '@/hooks/useChatImage';

interface Props {
  imageUrl: string;
  imageId: string;
  conversationId: string;
  messageId: string;
}

export function ChatImageActions({ imageUrl, imageId, conversationId, messageId }: Props) {
  const { t } = useTranslation();
  const [saved, setSaved] = useState(false);
  const saveMutation = useSaveToGallery();

  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = imageUrl;
    a.download = `chat-image-${imageId}.png`;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
  };

  const handleSaveToGallery = () => {
    saveMutation.mutate(
      { imageId, conversationId, messageId },
      { onSuccess: () => setSaved(true) },
    );
  };

  return (
    <div className="flex items-center gap-1.5 mt-1.5">
      <Button variant="ghost" size="sm" onClick={handleDownload} iconLeft={<Download className="h-3.5 w-3.5" />}>
        {t('chatImage.download')}
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleSaveToGallery}
        loading={saveMutation.isPending}
        disabled={saved}
        iconLeft={saved ? <Check className="h-3.5 w-3.5" /> : <ImagePlus className="h-3.5 w-3.5" />}
      >
        {saved ? t('chatImage.savedToGallery') : t('chatImage.saveToGallery')}
      </Button>
    </div>
  );
}
